import React, { ReactElement, useState, useEffect, useRef } from 'react';
import Dragger from 'antd/lib/upload/Dragger';
import { Col, message, Row, Select, Tooltip } from 'antd';
import SendRequest from '../../../shared/services/sendRequest.service';
import {
  FILE_UPLOAD, FILE_DOWNLOAD, STATUS_DONE, STATUS_REMOVED, FILE_UPLOAD_TYPE,
  APPLICATION_ID_2, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAIL, GUTTOR_SPACE_SMALL, DOCS_UPLOAD_NOTE,
} from '../../../shared/constants/commonConstants';
import DragableUploadListItem from './DragableUploadList';
import _ from 'lodash';
import { error } from '../../../utils/utility';
import { ReactComponent as UploadIcon } from '../../../assets/images/svg/i_upload.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/images/svg/i_download.svg';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/i_round_tick.svg';

interface IProps {
  folderData: any;
  uploadedFileDetails: any;
  removeUploadedFiles: any;
  isUploadDisabled: boolean;
}

const FileUpload = (props: IProps): ReactElement => {
  const { Option } = Select;
  const ref = useRef({ allDocs: null as any });
  const [uploadedFiles, setUploadedFiles] = useState([] as any);
  const [isApproved, setIsApproved] = useState(true);
  const [count, setCount] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [newUploadedFile, setNewUploadedFile] = useState([] as any);
  const sendRequest = SendRequest.instance;
  const fileUploadURL = process.env.REACT_APP_BASE_URL + FILE_UPLOAD;
  const fileDownloadURL = process.env.REACT_APP_BASE_URL + FILE_DOWNLOAD;
  const { folderData, uploadedFileDetails, removeUploadedFiles, isUploadDisabled } = props;
  const image = new Image();

  useEffect((): void => {
    dataValidationAndCollection();
  }, []);

  const dataValidationAndCollection = async (): Promise<any> => {
    await setUploadedFiles([]);
    const reFillfileList = [] as any;

    if (folderData && folderData.length > 0) {
      folderData.forEach((item: any): any => {
        if (!item.isApproved) {
          setIsApproved(false);
        }
        if (item.docId && item.docName) {
          reFillfileList.push(
            {
              uid: item.docId,
              size: '2000kb',
              name: item.docName,
              id: item.id,
              item,
              status: 'uploaded',
            },
          );
        }
      });
    }
    await setUploadedFiles(reFillfileList);
  };

  const fileUploadHandler = {
    name: 'file',
    multiple: true,
    beforeUpload: false,
    async onChange(info: any): Promise<any> {
      const localNewUploadedFile = newUploadedFile;
      if (info.file.status !== STATUS_REMOVED) {
        localNewUploadedFile.push(info.file);
        setNewUploadedFile(localNewUploadedFile);
        const formData = new FormData() as any;
        formData.append('FileUploadType', FILE_UPLOAD_TYPE);
        formData.append('ApplicationId', APPLICATION_ID_2);
        formData.append('file', info.fileList);

        const response = await sendRequest.upload(fileUploadURL, newUploadedFile) as any;
        if (response && response.isSuccess) {
          info.file.status = STATUS_DONE;
          uploadedFileDetails(response);
          setCount(response?.fileUploadDetails?.length);
        }
        if (response && response.isSuccess) {
          message.success(`${info.file.name} ${FILE_UPLOAD_SUCCESS}`);
        } else if (response && !response.isSuccess) {
          message.error(`${info.file.name} ${FILE_UPLOAD_FAIL}`);
        }
        setUploadedFiles(_.sortBy(info.fileList, 'lastModified'));
      }
    },
    showUploadList: {
      showDownloadIcon: true,
      downloadIcon: <DownloadIcon className="fill-gray mouse-pointer v-align-middle" />,
      showRemoveIcon: isApproved ? false : true,
    },

    onPreview(event: any): any {
      image.src = `${fileDownloadURL}/${event.uid}`;

      const w = window.open('') as any;
      w.document.write(image.outerHTML);
    },

    onRemove(event: any): void {
      const localUploadedFiles = uploadedFiles;
      const filteredFile = localUploadedFiles.filter((file: any): any => {
        return file?.id && event?.id ? file?.id === event?.id : file?.uid === event?.uid;
      });
      const filteredFileIndex = localUploadedFiles.indexOf(filteredFile[0]);
      localUploadedFiles.splice(filteredFileIndex, 1);
      setUploadedFiles(localUploadedFiles);
      removeUploadedFiles(event?.id ? { id: event?.id } : { uid: event?.name });
    },
  };

  const onFileAddition = (d: any): void => {
    uploadedFileDetails(d);
  };

  const onDocsFilter = (e: any): any => {
    if (!ref.current.allDocs) {
      ref.current.allDocs = [...uploadedFiles];
    }
    const tempDocs = ref.current.allDocs ? [...ref.current.allDocs] : [];
    const filteredDocs = tempDocs.filter((x: any): any =>
      e === 'Active' ? new Date(x?.item?.endDate) >= new Date() : e === 'Inactive' ? new Date(x?.item?.endDate) <= new Date() : true);
    setSelectedStatus(e);
    setUploadedFiles(filteredDocs);
    (filteredDocs && filteredDocs.length) ?
      setUploadedFiles(filteredDocs) : e === 'Active' ? error('No active record found') : error('No inactive record found');
  };

  return (
    <>
      <Dragger disabled={isUploadDisabled} {...fileUploadHandler} fileList={uploadedFiles} beforeUpload={(): any => false}
        itemRender={(originNode: any, file: any, currFileList: any): any => {
          return (
            <>
              <DragableUploadListItem
                originNode={originNode}
                file={file}
                fileList={currFileList}
                onFileAddition={onFileAddition}
              />
            </>
          );
        }}>
        <p className="text-center"><UploadIcon className="fill-primary" /></p>
        <p className="ant-upload-text">Drag & Drop your files here</p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload.
        </p>

      </Dragger>
      {((uploadedFiles && uploadedFiles.length > 0) || ref.current.allDocs) &&
        <Row className="original-node original-node-title" style={{ top: '197px', borderBottom: 0, position: 'absolute' }}
        gutter={GUTTOR_SPACE_SMALL}>
          <Col md={5}><span>File</span>  </Col>
          <Col md={5}>
            <Select bordered={false} value={selectedStatus}
              onChange={(e: any): any => onDocsFilter(e)}
              className="docs-filter-dropdown" onClick={(e: any): any => e.stopPropagation()}>
              <Option value="">All</Option>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Col>
          {count > 0 &&
            <span style={{ position: 'absolute', right: '12px', top: '3px', cursor: 'pointer' }}>
              <Tooltip title={DOCS_UPLOAD_NOTE}>
                <RoundTickIcon className="fill-success" />
              </Tooltip>
            </span>
          }

          <Col md={6}><span>Start date</span> </Col>
          <Col md={6}><span>End date</span> </Col>
        </Row>
      }
    </>
  );
};

export default FileUpload;
